import { useState, useEffect } from "react";

// Bootstrap components
import Container from "react-bootstrap/Container";

// Custom components
import Markets from "../components/Markets/Markets";

// API
import { getMarkets } from "../api/markets";

// Custom styles
import "../scss/pages/markets.styles.scss";

// Assets
import imgCreditoMd from "../assets/images/bg-credito-md.jpg";

import icon1 from "../assets/images/icon_mercados_manufactura.png";
import icon2 from "../assets/images/icon_mercados_transporte.png";
import icon3 from "../assets/images/icon_mercados_turismo.png";
import icon4 from "../assets/images/icon_mercados_medico.png";
import icon5 from "../assets/images/icon_mercados_agroindustrial.png";
import icon6 from "../assets/images/icon_mercados_agrope.png";
import icon7 from "../assets/images/icon_mercados_arrenda.png";
import icon8 from "../assets/images/icon_mercados_energias.png";
import icon9 from "../assets/images/icon_mercados_electrico.png";
import icon10 from "../assets/images/icon_mercados_tecno.png";
import icon11 from "../assets/images/icon_mercados_inmob.png";

import bgImage1 from "../assets/images/mercados_exportacion.jpg";
import bgImage2 from "../assets/images/mercados_transporte.jpg";
import bgImage3 from "../assets/images/mercados_turismo.jpg";
import bgImage4 from "../assets/images/mercados_medico.jpg";
import bgImage5 from "../assets/images/mercados_agro-ind.jpg";
import bgImage6 from "../assets/images/mercados_agro.jpg";
import bgImage7 from "../assets/images/mercados_arrendamiento_cero.jpg";
import bgImage8 from "../assets/images/mercados_energias_limpias.jpg";
import bgImage9 from "../assets/images/mercados_electrico_electronico.jpg";
import bgImage10 from "../assets/images/mercados_tecnologia.jpg";
import bgImage11 from "../assets/images/mercados_inmobilaria.jpg";

function MarketsPage() {
  const [activeTab, setActiveTab] = useState(0);

  // 2. Asignas la variable importada a la propiedad 'icon' de cada objeto
  const sectorsData = [
    {
      id: 0,
      icon: icon1,
      title: "Sector Empaque",
      text: (
        <>
          <h2 className="sector-title">
            Manufactura ligada a la <span>exportación e importación</span>
          </h2>
          <p>
            A través de nuestros productos financieros especializados,
            fomentamos la{" "}
            <strong>
              expansión y la eficiencia operativa, colaborando estrechamente
              para aprovechar oportunidades internacionales, competir en
              mercados globales y generar un impacto positivo en la comunidad y
              el medio ambiente
            </strong>{" "}
            apoyamos a empresas en la cadena de valor de importaciones y
            exportaciones, impulsando estrategias para aprovechar el{" "}
            <strong>efecto nearshoring</strong> en nuestro país, tales como:
          </p>
          <ul>
            <li>
              <strong>Maquila y Naves Industriales.</strong>
            </li>
            <li>
              <strong>Producción de Vehículos de motor.</strong>
            </li>
            <li>
              <strong>Telecomunicaciones.</strong>
            </li>
            <li>
              <strong>Productos metálicos.</strong>
            </li>
            <li>
              <strong>Industria Textil y de calzado.</strong>
            </li>
            <li>
              <strong>Fabricación de muebles.</strong>
            </li>
            <li>
              <strong>Artículos de piel.</strong>
            </li>
            <li>
              <strong>Manufacturas plástico y moldeo de piezas.</strong>
            </li>
            <li>
              <strong>Entre otras.</strong>
            </li>
          </ul>
        </>
      ),
      bgImage: bgImage1,
    },
    {
      id: 1,
      icon: icon2,
      text: (
        <>
          <h2 className="sector-title">
            <span>Transporte</span>
          </h2>
          <p>
            Apoyamos a empresas en el sector de{" "}
            <strong>transporte y logística terrestre</strong> que se
            especializan en el autotransporte de carga personalizado. Nuestras
            soluciones financieras están diseñadas para:{" "}
            <strong>
              Impulsar la expansión, mejorar la eficiencia operativa, facilitar
              la adaptación a necesidades específicas
            </strong>
          </p>
          <p>
            Trabajamos en estrecha colaboración para aprovechar oportunidades en
            el mercado y{" "}
            <strong>
              promover prácticas que optimicen la cadena de suministro,
              contribuyendo al crecimiento económico y al compromiso con la
              sostenibilidad.
            </strong>
          </p>
          <ul>
            <li>
              <strong>Actividades que apoyamos.</strong>
            </li>
            <li>
              <strong>Transporte y logística terrestre.</strong>
            </li>
            <li>
              <strong>Fletes especializados.</strong>
            </li>
            <li>
              <strong>Parque vehicular.</strong>
            </li>
            <li>
              <strong>Transporte de personal.</strong>
            </li>
            <li>
              <strong>Otros.</strong>
            </li>
          </ul>
        </>
      ),
      bgImage: bgImage2,
    },
    {
      id: 2,
      icon: icon3,
      text: (
        <>
          <h2 className="sector-title">
            <span>Turismo</span>
          </h2>
          <p>
            Impulsamos el sector turístico mediante una planificación financiera
            estratégica para{" "}
            <strong>incrementar, mejorar y fortalecer empresas</strong> con
            auténtico potencial. Buscamos diversificar la oferta turística y
            fomentar el crecimiento económico.
          </p>
          <p>
            Promovemos{" "}
            <strong>
              estándares de sostenibilidad, innovación y excelencia
            </strong>{" "}
            en el servicio.
          </p>
          <p>Apoyamos actividades como:</p>
          <ul>
            <li>
              <strong>Alimentos y Bebidas.</strong>
            </li>
            <li>
              <strong>Transporte.</strong>
            </li>
            <li>
              <strong>Alojamiento.</strong>
            </li>
            <li>
              <strong>Gastronomía.</strong>
            </li>
            <li>
              <strong>Agencias de viaje y tour operadores.</strong>
            </li>
            <li>
              <strong>Ocio y entretenimiento.</strong>
            </li>
            <li>
              <strong>Servicios auxiliares.</strong>
            </li>
            <li>
              <strong>Turismo de negocios.</strong>
            </li>
            <li>
              <strong>Turismo sostenible.</strong>
            </li>
            <li>
              <strong>Turismo médico.</strong>
            </li>
            <li>
              <strong>Mobiliario y equipo hotelero.</strong>
            </li>
            <li>
              <strong>Otros.</strong>
            </li>
          </ul>
        </>
      ),
      bgImage: bgImage3,
    },
    {
      id: 3,
      icon: icon4,
      text: (
        <>
          <h2 className="sector-title">
            Sector <span>Médico</span>
          </h2>
          <p>
            Apoyamos proyectos y empresas del sector privado que fomentan el{" "}
            <strong>
              bienestar social y la accesibilidad a servicios de calidad.
            </strong>
          </p>
          <ul>
            <li>
              <strong>Hospitales y clínicas.</strong>
            </li>
            <li>
              <strong>Dispositivos médicos.</strong>
            </li>
            <li>
              <strong>Consultorios médicos.</strong>
            </li>
            <li>
              <strong>Biotecnología Humana.</strong>
            </li>
            <li>
              <strong>Laboratorios clínicos.</strong>
            </li>
            <li>
              <strong>Farmacias.</strong>
            </li>
            <li>
              <strong>Equipos y dispositivos médicos.</strong>
            </li>
            <li>
              <strong>Terapias y rehabilitación.</strong>
            </li>
            <li>
              <strong>Servicios de salud mental.</strong>
            </li>
            <li>
              <strong>Telemedicina.</strong>
            </li>
            <li>
              <strong>Investigación médica.</strong>
            </li>
            <li>
              <strong>Servicios de emergencia.</strong>
            </li>
            <li>
              <strong>Otros.</strong>
            </li>
          </ul>
        </>
      ),
      bgImage: bgImage4,
    },
    {
      id: 4,
      icon: icon5,
      text: (
        <>
          <h2 className="sector-title">
            Sector <span>agroindustrial</span>
          </h2>
          <p>
            Nuestros productos financieros respaldan inversiones en tecnología,
            automatización y capital de trabajo, ayudando a las empresas a
            optimizar sus operaciones.
          </p>
          <p>
            Nos comprometemos con prácticas sostenibles para impulsar la
            eficiencia en la cadena de suministro, la manufactura y la
            producción de productos verdes.
          </p>
          <ul>
            <li>
              <strong>Agricultura.</strong>
            </li>
            <li>
              <strong>Ganadería.</strong>
            </li>
            <li>
              <strong>Forestal.</strong>
            </li>
            <li>
              <strong>Pesca.</strong>
            </li>
          </ul>
        </>
      ),
      bgImage: bgImage5,
    },
    {
      id: 5,
      icon: icon6,
      text: (
        <>
          <h2 className="sector-title">
            Sector <span>agropecuario</span>
          </h2>
          <p>
            Apoyamos a productores en la adopción de prácticas responsables y
            sostenibles.
          </p>
          <p>Nuestras soluciones financieras promueven:</p>
          <p>
            Uso eficiente de recursos naturales, la salud del suelo y el medio
            ambiente, impulsando una economía circular.
          </p>
          <p>
            Nos enfocamos a que los cultivos sean a cielo cerrado y que cuenten
            con contratos de comercialización con empresas reconocidas.
          </p>
          <ul>
            <li>
              <strong>Agricultura.</strong>
            </li>
            <li>
              <strong>Ganadería.</strong>
            </li>
            <li>
              <strong>Forestal.</strong>
            </li>
            <li>
              <strong>Pesca.</strong>
            </li>
          </ul>
        </>
      ),
      bgImage: bgImage6,
    },
    {
      id: 6,
      icon: icon7,
      text: (
        <>
          <h2 className="sector-title">
            <span>Arrendamiento cero emisiones</span>
          </h2>
          <p>
            Ofrecemos soluciones de{" "}
            <strong>
              arrendamiento con cero emisiones para empresas de todos los
              sectores.
            </strong>
          </p>
          <p>
            Nuestras soluciones financieras están diseñadas para:{" "}
            <strong>
              Impulsar la expansión mediante el uso de tecnologías limpias y
              sostenibles, mejorar la eficiencia operativa con equipos y
              vehículos que no emiten gases contaminantes, facilitar la
              adaptación a necesidades específicas con opciones de arrendamiento
              personalizadas.
            </strong>
          </p>
          <p>
            Trabajamos en estrecha colaboración para{" "}
            <strong>
              aprovechar oportunidades en el mercado y promover prácticas que
              optimicen la cadena de suministro, contribuyendo al crecimiento
              económico y al compromiso con la sostenibilidad.
            </strong>
          </p>
        </>
      ),
      bgImage: bgImage7,
    },
    {
      id: 7,
      icon: icon8,
      text: (
        <>
          <h2 className="sector-title">
            Energías <span>Limpias</span>
          </h2>
          <p>
            Ofrecemos soluciones de financiamiento para empresas dedicadas a las
            energías limpias:
          </p>
          <p>
            <strong>Instalación de paneles solares:</strong> empresas que
            diseñan, instalan y mantienen sistemas de energía solar fotovoltaica
            para hogares, empresas y proyectos a gran escala.
          </p>
          <p>
            <strong>Parques Eólicos:</strong> compañías dedicadas a la
            construcción y operación de aerogeneradores para generar
            electricidad a partir del viento.
          </p>
          <p>
            <strong>Plantas Hidroeléctricas:</strong> Negocios que desarrollan y
            operan infraestructuras para aprovechar el flujo de agua y generar
            electricidad.
          </p>
          <p>
            <strong>Energía Geotérmica:</strong> Empresas que exploran y
            explotan recursos térmicos subterráneos para producir electricidad o
            calefacción.
          </p>
        </>
      ),
      bgImage: bgImage8,
    },
    {
      id: 8,
      icon: icon9,
      text: (
        <>
          <h2 className="sector-title">
            Sector <span>Eléctrico - Electrónico</span>
          </h2>
          <p>
            Promovemos la inversión en{" "}
            <strong>
              energía y sistemas eléctricos seguros y eficientes, a la par que
              impulsamos la implementación de tecnología electrónica innovadora:
            </strong>{" "}
            equipo de audio y video, electricidad e iluminación, equipos de
            comunicación, entre otros.
          </p>
        </>
      ),
      bgImage: bgImage9,
    },
    {
      id: 9,
      icon: icon10,
      text: (
        <>
          <h2 className="sector-title">
            <span>Tecnología</span>
          </h2>
          <p>
            Impulsamos la innovación de soluciones que mejoren la eficiencia,
            productividad y conectividad de todas las industrias. Ofrecemos{" "}
            <strong>
              soluciones en robótica, biotecnología, nanotecnología, tecnologías
              de la Información, entre otros.
            </strong>
          </p>
        </>
      ),
      bgImage: bgImage10,
    },
    {
      id: 10,
      icon: icon11,
      text: (
        <>
          <h2 className="sector-title">
            <span>Desarrollos Inmobiliarios</span>
          </h2>
          <p>
            Ofrecemos soluciones financieras especializadas para{" "}
            <strong>
              proyectos inmobiliarios, con un firme enfoque en la sostenibilidad
              y el respeto por el medio ambiente.
            </strong>
          </p>
          <p>
            Nos dedicamos a impulsar el desarrollo de propiedades que cumplen
            con altos estándares de construcción sostenible, promoviendo
            entornos más verdes y resilientes.
          </p>
          <p>
            Entre nuestras iniciativas destacadas se encuentra:{" "}
            <strong>
              Modernización de edificios para reducir emisiones de carbono y
              fomentar prácticas de construcción ecológica.
            </strong>
          </p>
        </>
      ),
      bgImage: bgImage11,
    },
  ];

  return (
    <div className="page-mercados">
      <section className="seccion-mercados-hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-lg-7 text-column">
              <h2 className="markets-title">
                Impulsamos el crecimiento
                <br />
                de{" "}
                <span className="text-green">más de 28 industrias.</span>{" "}
              </h2>

              <p>
                Nuestras soluciones financieras{" "}
                <strong>
                  están diseñadas para atender{" "}
                  <br className="d-none d-xl-block" />
                  diferentes mercados.
                </strong>{" "}
                Trabajamos de cerca con sectores clave,{" "}
                <br className="d-none d-xl-block" />
                brindando apoyo financiero especializado para impulsar el
                crecimiento <br className="d-none d-xl-block" />
                en cada uno de ellos.
              </p>

              <p>
                Comprendemos las necesidades específicas de cada mercado y{" "}
                <br className="d-none d-xl-block" />
                <strong>proporcionamos soluciones integrales</strong> para
                satisfacerlas, considerando <br className="d-none d-xl-block" />
                siempre el impacto ambiental, social, y la sostenibilidad de los{" "}
                <br className="d-none d-xl-block" />
                proyectos.
              </p>
              <br></br>
            </div>

            <div className="col-12 col-lg-4 offset-lg-1 stat-column mt-5 mt-lg-0">
              <div className="stat-card">
                <div className="stat-number">
                  28<span className="text-black">+</span>
                </div>
                <p className="stat-text">
                  mercados en los <br />
                  que nos hemos <br />
                  especializado.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TABS */}
      <section className="seccion-mercados-tabs">
        <div className="container">
          <div className="row mb-5">
            <div className="col-12 col-lg-8">
              <h2 className="sectors-heading">
                Enseguida te presentamos{" "}
                <span className="text-green">
                  los sectores de <br className="d-none d-md-block" />
                  mercados en los que nos hemos especializado.
                </span>
              </h2>
            </div>
          </div>

          <div className="row g-0 tabs-main-container">
            <div className="col-auto tabs-sidebar">
              <div className="nav nav-pills" role="tablist">
                {sectorsData.map((sector, index) => (
                  <button
                    key={sector.id}
                    className={`nav-link tab-icon-btn ${activeTab === index ? "active" : ""}`}
                    onClick={() => setActiveTab(index)}
                    type="button"
                    role="tab"
                  >
                    <img
                      src={sector.icon}
                      alt={sector.title}
                      className="sector-icon-img"
                    />
                  </button>
                ))}
              </div>
            </div>

            <div className="col tabs-content-area">
              {sectorsData.map((sector, index) => (
                <div
                  key={sector.id}
                  className={`tab-pane fade ${activeTab === index ? "show active" : ""}`}
                  role="tabpanel"
                >
                  <div className="content-wrapper">
                    <div
                      className="background-image"
                      style={{ backgroundImage: `url(${sector.bgImage})` }}
                    ></div>
                    <div className="text-box">
                      <div className="sector-description">{sector.text}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* TABS */}

      <section className="seccion-mercados-compromiso">
        <div className="container-fluid p-0">
          <div className="row g-0 align-items-center">
            <div className="col-12 col-lg-6 d-none d-lg-block">
              <div className="cont-bg-image"></div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="commitment-text-box">
                <p className="commitment-text">
                  <span className="text-green">
                    Nuestro compromiso es comprender las{" "}
                    <br className="d-none d-xl-block" />
                    necesidades específicas de cada mercado
                  </span>{" "}
                  y <br className="d-none d-xl-block" />
                  proporcionar soluciones integrales para{" "}
                  <br className="d-none d-xl-block" />
                  satisfacerlas, considerando siempre el impacto{" "}
                  <br className="d-none d-xl-block" />
                  ambiental, social, y la sostenibilidad de los{" "}
                  <br className="d-none d-xl-block" />
                  proyectos.
                </p>
              </div>
            </div>

            <div className="col-12 col-lg-6 text-center d-lg-none">
             <img src={imgCreditoMd} alt="" className="md-foto" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default MarketsPage;

/*       <section className="about">
        <div className="container-fluid">
          <div className="about__row">
            <div className="about__row__body">
              <h5 className="about__row__body_name">{marketsData.subTitle}</h5>
              <h2 className="about__row__body_title">{marketsData.title}</h2>
            </div>
            <div className="about__row__container">
              <img
                src={`${process.env.REACT_APP_HOME_API_URL}${marketsData.marketsMedia.url}`}
                className="img-fluid about__row__container_img"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
      <section className="marketsClass">
        <div className="container container_fluid_about">
          <h4 className="markets_name">Todos nuestros mercados:</h4>
          <ul
            className="nav nav-pills mb-3 nav_pills"
            id="pills-tab"
            role="tablist"
          >
            {marketsData.markets.map((market, index) => {
              const trimmedTitle = market.marketTitle.replace(/\s/g, "");

              return (
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link button"
                    id={index}
                    data-bs-toggle="pill"
                    data-bs-target={`#pill-${trimmedTitle}`}
                    type="button"
                    role="tab"
                    aria-controls={`pill-${trimmedTitle}`}
                    aria-selected="false"
                    onClick={() =>
                      {
                        const targetElement =
                          document.getElementById("pills-tabContent");

                        if (targetElement) {
                          targetElement.scrollIntoView({ behavior: "smooth" });
                        }
                      }
                    }
                  >
                    <img src={checkIcon} alt="" />
                    <h5 className="button_text ms-2 ms-lg-0">
                      {market.marketTitle.replace(/\s/g, " ")}
                    </h5>
                  </button>
                </li>
              );
            })}
          </ul>

          <div className="tab-content" id="pills-tabContent">
            {marketsData.markets.map((market, index) => {
              const trimmedTitle = market.marketTitle.replace(/\s/g, "");

              return (
                <Markets
                  key={index}
                  id={`pill-${trimmedTitle}`}
                  aLabelledby={`pill-${trimmedTitle}-tab`}
                  name={market.marketTitle}
                  marketShortDescription={market.marketShortDescription}
                  text={market.marketAbout}
                  beneficios={market.benefits}
                />
              );
            })}
          </div>
        </div>
      </section> */
